/**
 * Icône d'onglet (favicon) & titre de page dynamiques.
 * Sur le site d'un resto, l'onglet affiche le LOGO du resto et son nom ; ailleurs
 * (pages génériques, super admin), on garde le favicon Lil & Co par défaut (index.html).
 * DOM-only, sans dépendance ; sans effet si pas de document (SSR/tests).
 */

const DEFAULT_ICON = '/lilco-favicon.png';

/** Pose l'icône d'onglet (URL d'image). Repli sur le logo Lil & Co si vide. */
export function setSiteIcon(url: string | null | undefined): void {
  if (typeof document === 'undefined') return;
  const href = (url ?? '').trim() || DEFAULT_ICON;
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

/** Définit le titre de l'onglet. */
export function setSiteTitle(title: string | null | undefined): void {
  if (typeof document === 'undefined') return;
  const t = (title ?? '').trim();
  if (t) document.title = t;
}

/**
 * Applique l'identité d'onglet d'un resto : logo + « {Nom} — Commande en ligne ».
 * À appeler après le chargement du tenant (site client / admin / tablette).
 */
export function applyTenantTabIdentity(name: string, logoUrl: string | null | undefined): void {
  setSiteIcon(logoUrl);
  setSiteTitle(`${name} — Commande en ligne`);
}
